import React, { useEffect, useRef } from "react";

/**
 * Works just like useEffect, except that this hook does not trigger on the initial rendering.
 */
const useAfterMountEffect = (
  func: () => void,
  deps: React.DependencyList | undefined
) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useAfterMountEffect;
